import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";
import { resetStateCompanyDetail } from "./companyDetailSlice";

//create action
export const updateCompany = createAsyncThunk(
  "updateCompany",
  async ({ id, data, form, history }, thunkAPI) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.patch(
      `company/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    thunkAPI.dispatch(resetStateCompanyDetail());
    message.success("Company successfully updated!");
    history("/app/organization/company");
    return response.data;
  }
);

const companyUpdateSlice = createSlice({
  name: "companyUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateCompany.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateCompany.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateCompany.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default companyUpdateSlice.reducer;